<template>
    <button @click="toggleButton" v-html="internalText" :disabled="disabled" :class="[clazz]" />
</template>

<script>
    export default {
        name: "toggleable-button",
        props: ["id", "text", "initialState"],
        data() {
            return {
                clazz: "",
                state: false,
                disabled: false,
                internalText: "✘ " + this.text,
            };
        },
        mounted() {
            if (this.initialState) {
                this.toggleButton();
            }
        },
        methods: {
            toggleButton() {
                this.state = !this.state;

                this.refreshState();
            },
            refreshState(triggerEvent = true) {
                if (this.state) {
                    this.clazz = "active is-active";
                    this.internalText = "✔ " + this.text;
                } else {
                    this.clazz = " ";
                    this.internalText = "✘ " + this.text;
                }

                if (triggerEvent) {
                    this.$emit("stateChange", this.id, this.state);
                }
            },
            isEnabled() {
                return !!this.state;
            },
            setState(state, triggerEvent = true) {
                this.state = state;
                this.refreshState(triggerEvent);
            },
            /**
             * No idea why these two below are needed. Consider removing them.
             */
            enable() {
                this.disabled = false;
            },
            disable() {
                this.disabled = true;
            },
        },
    };
</script>
